import React from "react";

interface AppLayoutProps {
  titleBar: React.ReactNode;
  /** Open-document tab strip, shown under the titlebar when more than one PDF is open. */
  tabBar?: React.ReactNode;
  banner?: React.ReactNode;
  /** Main content region — the viewer (which owns thumbnails|page) or empty state. */
  main: React.ReactNode;
  /** Right-hand tool rail; omitted when no document is open. */
  sidebar?: React.ReactNode;
  statusBar: React.ReactNode;
}

/**
 * Presentational desktop frame:
 *   [ title bar ]
 *   [ tab bar ]
 *   [ main (thumbnails | viewer)  |  tool sidebar ]
 *   [ status bar ]
 * Keeps structure out of DesktopApp so the composition root stays about wiring.
 */
const AppLayout: React.FC<AppLayoutProps> = ({
  titleBar,
  tabBar,
  banner,
  main,
  sidebar,
  statusBar,
}) => {
  return (
    <div className="app-layout">
      <header className="app-titlebar-slot">{titleBar}</header>
      {tabBar}
      {banner}
      <div className="app-body">
        <div className="app-content">{main}</div>
        {sidebar}
      </div>
      <footer className="app-statusbar-slot">{statusBar}</footer>
    </div>
  );
};

export default AppLayout;
